// extracted by mini-css-extract-plugin
export var bottomRightDock = "_22-0";